import useMountEffect from '@restart/hooks/useMountEffect';
import { useNavigate } from 'react-router-dom';

const UnprotectedRoute = ({ allowWhenAuthenticated = false, children }) => {
  const navigate = useNavigate();

  useMountEffect(() => {
    if (allowWhenAuthenticated) {
      return;
    }

    const token = localStorage.getItem('@h2tms/token');
    const role = localStorage.getItem('@h2tms/role');

    if (token !== null && role !== null) {
      navigate('/');
    }
  });

  return children;
};

export default UnprotectedRoute;
